<template>
  <div>
    <h1 class="c-heading">お問い合わせ</h1>
    <p class="c-description">
      ご記入いただいた個人情報は、お問い合わせ対応以外には使用いたしません。
      当社はお客様情報の適正な収集・利用およびその保護に努めています。
      ご記入頂きました情報の取扱いにつきましては「プライバシーポリシー」をご覧ください。
      お問い合わせ入力フォームに必要事項を入力の上、「確認画面へ」ボタンをクリックして下さい。
    </p>

    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
      <form id="contact-form" @submit.prevent="handleSubmit(toConfirm)">
        <div v-if="!isMobile" class="c-formBlock u-contentPc">
          <div class="c-formBlock__heading">
            <label class="c-formBlock__title" for="name">お名前</label>
            <span class="c-formBlock__required">必須</span>
          </div>
          <div class="c-formBlock__content c-formBlock__content--name">
            <ValidatedInput
              v-model="requestBody.name" vid="name" placeholder="姓名" type="text" name="姓名" id="name" rules="required" class="c-formBlock__input"
            />
            <ValidatedInput
              v-model="requestBody.kana" vid="name_kana" placeholder="フリガナ" type="text" name="フリガナ" id="name_kana" rules="required" class="c-formBlock__input"
            />
          </div>
        </div>

        <div v-else>
          <div class="c-formBlock u-contentSp">
            <div class="c-formBlock__heading">
              <label class="c-formBlock__title" for="name">お名前</label>
              <span class="c-formBlock__required">必須</span>
            </div>
            <div class="c-formBlock__content c-formBlock__content--name">
              <ValidatedInput
                v-model="requestBody.name" vid="name" placeholder="姓名" type="text" name="姓名" id="name" rules="required" class="c-formBlock__input"
                />
            </div>
          </div>

          <div class="c-formBlock u-contentSp">
            <div class="c-formBlock__heading">
              <label class="c-formBlock__title" for="name_kana">フリガナ</label>
              <span class="c-formBlock__required">必須</span>
            </div>
            <div class="c-formBlock__content c-formBlock__content--name">
              <ValidatedInput
                v-model="requestBody.kana" vid="name_kana" placeholder="フリガナ" type="text" name="フリガナ" id="name" rules="required" class="c-formBlock__input"
                />
            </div>
          </div>
        </div>

        <div class="c-formBlock c-formBlock--mailAddress">
          <div class="c-formBlock__heading">
            <label class="c-formBlock__title" for="mail_address"
              >メールアドレス</label
            >
            <span class="c-formBlock__required">必須</span>
          </div>
          <div class="c-formBlock__content">
            <ValidatedInput
              v-model="requestBody.email" vid="mail_address" :expandedTooltip="true" type="text" name="メールアドレス" id="mail_address" rules="required|email" class="c-formBlock__input"
            />
          </div>
        </div>

        <div class="c-formBlock">
          <div class="c-formBlock__heading">
            <label class="c-formBlock__title" for="message"
              >お問い合わせ内容</label
            >
            <span class="c-formBlock__required">必須</span>
          </div>
          <div class="c-formBlock__content">
            <ValidationWrapper rules="required">
              <template v-slot:default="slotProps">
                <textarea
                  name="お問い合わせ内容"
                  id="message"
                  @focus="slotProps.clear"
                  class="c-formBlock__textarea"
                  v-model="requestBody.message"
                />
              </template>
            </ValidationWrapper>
          </div>
        </div>
          <div class="c-formBlock c-formBlock--button">
            <div class="c-formBlock__heading"></div>
            <div class="c-formBlock__content c-formBlock__content--buttons">
              <common-button
                class="u-mR10"
                :title="'確認画面へ'"
                :middle="true"
                :border_red="true"
                :font_size="'16px'"
                :font_bold="true"
                :width="'120px'"
                :submit_type="true"
                :attr="[]"
              />
              <common-button
                :title="'クリア'"
                :middle="true"
                :font_size="'16px'"
                :callback="clearBtn"
                :font_bold="true"
                :width="'120px'"
                :attr="[]"
              />
            </div>
          </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ValidatedInput from '@/components/common/validation/ValidatedInput';
import ValidationWrapper from '@/components/common/validation/ValidationWrapper';
import CommonButton from '@/components/parts/button/CommonButton';

export default {
  name: 'ContactForm',
  mixins: [IsMobileMixin],
  props: ['isPage', 'userData', 'requestBody'],
  components: {
    ValidationProvider,
    ValidationObserver,
    ValidatedInput,
    ValidationWrapper,
    CommonButton,
  },
  data() {
    return {};
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
    isPageChild: {
      get() {
        return this.isPage;
      },
      set(isPage) {
        this.$emit('input', isPage);
      },
    },
  },
  created() {
    if (this.isLoggedIn) {
      if (this.userData !== {}) {
        this.requestBody.name = `${this.userData.sei} ${this.userData.mei}`;
        this.requestBody.kana = `${this.userData.seikana} ${this.userData.meikana}`;
        this.requestBody.email = this.userData.email;
      }
    }
  },
  methods: {
    async toConfirm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      this.isPageChild = 'conf';
    },
    clearBtn() {
      this.requestBody.name = '';
      this.requestBody.kana = '';
      this.requestBody.email = '';
      this.requestBody.message = '';
      this.$refs.observer.reset();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

.c-formBlock {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 10px;

  &--mailAddress {
    align-items: center;
  }
  &--button {
    margin-top: 20px;
  }
  &__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(30% - 20px);
    margin-right: 20px;
  }
  &__title {
    font-family: "メイリオ", "Meiryo", sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: #666;
    line-height: 1.2;
  }
  &__required {
    padding: 6px 4px;
    margin-left: 10px;
    font-size: 12px;
    color: #fff;
    background: #ff0000;
    white-space: nowrap;
  }
  &__content {
    width: 70%;

    &--name {
      ::v-deep input {
        width: 50%;
      }
      ::v-deep:first-of-type input {
        margin-bottom: 10px;
      }
    }
    &--buttons {
      display: flex;
    }
  }
  &__input {
    width: 100%;
  }
  &__textarea {
    padding: 8px;
    line-height:1.5em;
    width: 100%;
    height: 240px;
    border: 1px solid #ccc;
  }
}

.c-heading {
  margin: 0 0 40px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  line-height: 1.5;
  text-align: center;
  font-family: "メイリオ", "Meiryo", sans-serif;
}

.c-description {
  width: 100%;
  max-width: 570px;
  margin: 0 auto 40px;
  font-size: 14px;
  color: #666;
  line-height: 2;
  font-family: "メイリオ", "Meiryo", sans-serif;
}

.u-contentPc {
  display: flex;
}
.u-contentSp {
  display: none;
}
.u-mR10 {
  margin-right: 10px;
}

@media screen and (max-width: 767px) {
  .c-heading {
    font-size: 18px;
    margin-bottom: 24px;
  }
  .c-description {
    margin-bottom: 32px;
  }
  .c-formBlock {
    flex-wrap: wrap;
    margin-top: 20px;

    &__heading {
      justify-content: flex-start;
      width: 100%;
      margin-right: 0;
      margin-bottom: 5px;
    }
    &__content {
      width: 100%;

      &--name {
        ::v-deep input {
          width: 100%;
        }
      }
    }
    &__input {
      background: #fff;
    }
    &__textarea {

      ::v-deep textarea {
        height: 214px;
        background: #fff;
      }
    }
  }
  .u-contentPc {
    display: none;
  }
  .u-contentSp {
    display: block;
  }
}
</style>
